import { useEffect, useState } from 'react'
import { nanoid } from '@reduxjs/toolkit'

import TripleDotPopupWrapper from 'common/components/TripleDotPopupWrapper'

interface IProfileListItemProps {
  children: React.ReactNode
  isSelected?: boolean | string
  itemKey?: string
  dropdownSectionRenderer?: () => JSX.Element
  // When the main label (not the dropdown options) is selected
  onDefaultSelect?: (itemKey: string) => void
}

const ProfileListItem = ({
  children,
  isSelected,
  itemKey,
  dropdownSectionRenderer,
  onDefaultSelect
}: IProfileListItemProps) => {
  const [componentKey] = useState(itemKey ?? nanoid())
  const [isSelectedBool, setIsSelectedBool] = useState(false)

  useEffect(() => {
    if (typeof isSelected === 'boolean') {
      setIsSelectedBool(isSelected)
    } else if (typeof isSelected === 'string') {
      setIsSelectedBool(isSelected === componentKey)
    }
  }, [isSelected, componentKey])

  return (
    <div
      className={[
        'flex items-center rounded-sm',
        isSelectedBool ? 'bg-lighthouseBlue bg-opacity-20' : ''
      ].join(' ')}
    >
      <button
        className={[
          'flex-1 px-2 py-2.5',
          'text-left font-semibold'
        ].join(' ')}
        onClick={() => onDefaultSelect?.(componentKey)}
      >
        {children}
      </button>
      <TripleDotPopupWrapper
        dropdownSectionRenderer={dropdownSectionRenderer}
      />
    </div>
  )
}

export default ProfileListItem
